export default __webpack_public_path__ + "static/media/defaultclassimg.7174fcbf.png";